import { computePromotionalPriceForQuantity } from '@keplr/order-accounting';

import { RecipeIngredientProductArticle } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/types';

const computeTotalPrice = (ingredientsArticle: RecipeIngredientProductArticle[]) =>
  ingredientsArticle.reduce((acc, { itemPrice, promo, quantity }) => {
    const price = promo?.conditions
      ? computePromotionalPriceForQuantity(
          itemPrice ?? 0,
          { ...promo, conditions: promo.conditions },
          quantity,
        ).total
      : (itemPrice ?? 0) * quantity;

    return acc + price;
  }, 0);

export default computeTotalPrice;
